module.exports = __webpack_public_path__ + "static/media/gps.62fdc7c8.svg";